import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
// import AlertManager from "../shared/Alert/Alert";

export const getSVCUploadHistory = async (params) => {

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
        return;
    }
    let queryParams = new URLSearchParams(params).toString();

    const apiUrl = localDatabaseUrls.baseURL + localDatabaseUrls.serviceURL.svcUploadHistory + (queryParams ? "?" + queryParams : "")

    // const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.cjwUploadHistory}`;

    const response = await getAPI(apiUrl, tokenInfo);

    if (response.status === 200 || response.status === 201) {
        return response.json();
    } else {
        // response.status === 404 ? AlertManager.error("File not found in bucket", { contactSupport: false }) : AlertManager.error("Error downloading file", { contactSupport: false });

        console.error("Error while getting cost upload history:", response.statusText);
        return { content: [], totalPages: 0 };
    }

};